/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { HeaderNavBar } from "./header-nav-bar";
import { HeaderTopBar } from "./header-top-bar";


const Header = () => {

    return (
        <div className='header'>
            <HeaderTopBar />
            <HeaderNavBar />
        </div>
    );
};

export { Header };
